import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from '@/Foundation/Shared/platform/app/module';

import { CustomizerFeaturesComponent } from './customizer-features.component';
import { CustomizerProductInfoComponent } from './customizer-product-info.component';

@NgModule({
  declarations: [
    CustomizerProductInfoComponent,
    CustomizerFeaturesComponent,
  ],
  id: `gn.audio.public.customizer-product-info`,
  imports: [SharedModule],
  providers: [],
})
export class CustomizerProductInfoModule {
}
